
const checkEmail = (val) => {
    if (val.length == 0) {
        return 'Адрес электронной почты не указан';
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(val)) {
        return 'Неверный формат адреса электронной почты';
    }

    return '';
}

const checkPhone = (val, completed) => {
    if (val.length == 0) {
        return 'Номер телефона не указан';
    }

    if (val.length && !completed) {
        return 'Номер телефона введён не полностью';
    }

    return '';
}

const plural = (n, form1, form2, form5) => {
    n = Math.abs(n) % 100
    const n1 = n % 10
    if (n > 10 && n < 20) return form5
    if (n1 > 1 && n1 < 5) return form2
    if (n1 == 1) return form1
    return form5
}

export { checkEmail, checkPhone, plural }
